import { PropsWithChildren, ReactNode } from 'react';
import cn from 'classnames';
import { SectionLoader } from '@/shared/ui/Loader';
import { getCourseDebtError } from '@/shared/lib/utils/getCourseDebtError';
import { CourseDebtNotice } from '../CourseDebtNotice';
import { ErrorWidget } from '../ErrorWidget/ErrorWidget';

interface ContentStateProps extends PropsWithChildren {
  isLoading?: boolean;
  isEmpty?: boolean;
  isError?: boolean;
  errorMessage?: string;
  /** Сырая ошибка запроса. Нужна, чтобы отличить отказ по долгу от обычной поломки. */
  error?: unknown;
  emptyMessage?: string;
  emptyContent?: ReactNode;
  className?: string;
  emptyClassName?: string;
  asSection?: boolean;
}

export const ContentWrapper = ({
  isLoading,
  isEmpty,
  isError,
  errorMessage,
  error,
  emptyMessage,
  emptyContent,
  children,
  className,
  emptyClassName,
  asSection = false,
}: ContentStateProps) => {
  if (isLoading) {
    return <SectionLoader className={className} />;
  }

  if (isError) {
    const debt = getCourseDebtError(error);

    if (debt) {
      return <CourseDebtNotice debt={debt} />;
    }

    return <ErrorWidget error={errorMessage || 'Failed to load data'} />;
  }

  if (isEmpty) {
    if (emptyContent) {
      return <div className={cn(className, emptyClassName)}>{emptyContent}</div>;
    }

    return (
      <div
        className={cn(
          'w-full flex justify-center items-center min-h-[400px]',
          className,
          emptyClassName,
        )}
      >
        <p className="text-lg text-grey font-medium">
          {emptyMessage || 'No data available.'}
        </p>
      </div>
    );
  }

  return (
    <>
      {asSection ? (
        <section className={className}>{children}</section>
      ) : (
        <div className={className}>{children}</div>
      )}
    </>
  );
};
